import ExternalAccessList from '@/components/external-access/ExternalAccessList'
import ExternalAccessCreate from '@/components/external-access/ExternalAccessCreate'

export default [
  {
    path: '/acces-externe',
    name: 'ExternalAccessList',
    component: ExternalAccessList,
    meta: {
      parentName: 'Home',
      requiresAuth: true,
      needProfile: ['admin']
    }
  },
  {
    path: '/acces-externe/creation',
    name: 'ExternalAccessCreate',
    component: ExternalAccessCreate,
    meta: {
      parentName: 'ExternalAccessList',
      requiresAuth: true,
      needProfile: ['admin']
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/externalAccessRouter.js